/** @format */

import { Component, Input, OnInit } from '@angular/core';

import { Badge } from './badge.interface';

@Component({
	selector: 'clp-mwc-badge',
	templateUrl: './badge.component.html',
	styleUrl: './badge.component.scss',
	standalone: false
})
export class BadgeComponent implements OnInit {
	public badge: Badge = new Badge('none', '', '');

	@Input() data: any;

	ngOnInit() {
		for (const attributes of this.data) {
			this.badge = new Badge(
				attributes.badgeType,
				attributes.backgroundColor,
				attributes.foregroundColor
			);
		}
	}
}
